<template>
  <div class="center">
    <date-pick
      v-if="$store.state.i18n.locale === 'fr'"
      v-model="date"
      :displayFormat="displayFormatPRP"
      :format="formatPRP"
      :pickTime="pickTimePRP"
      :use12HourClock="use12HourClockPRP"
      :hasInputElement="hasInputElement"
      :inputAttributes="{readonly: true}"
      :nextMonthCaption="frenchLocalization.nextMonth"
      :prevMonthCaption="frenchLocalization.prevMonth"
      :weekdays="frenchLocalization.weekdays"
      :months="frenchLocalization.months"
      class="container-width_max"
      @input="onDateSelect(date)"
    />
    
    <date-pick
      v-if="$store.state.i18n.locale === 'en'"
      v-model="date"
      :displayFormat="displayFormatPRP"
      :format="formatPRP"
      :pickTime="pickTimePRP"
      :use12HourClock="use12HourClockPRP"
      :hasInputElement="hasInputElement"
      :inputAttributes="{readonly: true}"
      class="container-width_max"
      @input="onDateSelect(date)"
    />
  </div>
</template>

<script>
import DatePick from 'vue-date-pick'
import 'vue-date-pick/dist/vueDatePick.css'

export default {
  name: 'CustomDatePick',
  data () {
    return {
      date: '',
      frenchLocalization: {
        nextMonth: 'Mois prochain',
        prevMonth: 'Mois précédant',
        weekdays: ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'],
        months: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre']
      }
    }
  },
  /** VueJS documentation at
   * @link https://dbrekalo.github.io/vue-date-pick/getting-started.html
   * */

  props: {
    displayFormatPRP: {
      type: String,
      required: false
    },
    formatPRP: {
      type: String,
      required: true
    },
    pickTimePRP: {
      type: Boolean,
      required: true
    },
    use12HourClockPRP: {
      type: Boolean,
      required: true
    },
    hasInputElement: {
      type: Boolean,
      required: true
    }
  },
  components: {
    DatePick
  },
  methods: {
    /** Emits the time to the component that called it. Format: DD/MM/YYYY */
    onDateSelect (date) {
      const now = new Date()
      const currentHours = now.getHours() + (now.getMinutes() / 60) + (now.getSeconds() / 3600)
      const formattedDate = this.formatDate(date, currentHours)
      this.$emit('updateDatePick', formattedDate)
    },

    formatDate (date, hours) {
      const dateSplit = date.split('/')
      const time = hours * 3600 // Hours to seconds

      let newDate = new Date(dateSplit[0], dateSplit[1] - 1, dateSplit[2])
      // const timestamp = (newDate.getTime() / 1000) + time || Returns proper timestamp value (Using timestamp converters will give 20XX years)
      const timestamp = newDate.getTime() + (time * 1000) // Returns timestamp value that works with internal function "getDate()" (Using timestamp converters will give 50000+ years)
      return timestamp
    }
  }
}
</script>

<style>
  .container-width_max {
    min-width: 10rem;
    max-width: 25rem;
  }

  .vdpClearInput {
    right: 4px !important;
  }

  .vdpWithInput > input {
    font-size: 15px;
  }

  .vdpInnerWrap {
    padding: 0px;
  }
</style>
